import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeaderSearch from './HeaderSearch';
import { SubscribeRibbon } from './SubscribeRibbon';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import {Helmet} from "react-helmet";
import { useNavigate } from 'react-router-dom';

function Hotel() {
  const { id, cityName, title } = useParams();
  const [hotelData, setHotelData] = useState({});
  const { 
    name
    ,short_description
    ,description
    ,hotel_image
    ,feature_images
    ,home_feature_images
    ,image_featured
    ,home_image_featured
    ,thumbnail_image
    ,city
    ,state
    ,neighborhood
    ,nighborhoodcity
    ,star_rating
    ,group
    ,logo_image
    ,location
    ,latitude
    ,longitude
    ,address
    ,zipcode
    ,type
    ,status
    ,interest_type
    ,category_type
    ,budget_type
    ,premium
    ,room
    ,available_date
    ,price
    ,roomtype
    ,available
    ,videos
    ,article
    ,featured
    ,contact_person
    ,contact_number
    ,contact_numbertw
    ,contact_address
    ,contact_person_hotel
    ,contact_number_hotel
    ,Percentage_commission_hotel
    ,special_rate
    ,email_id_hotel
    ,Address_hotel
    ,booking_office_number
    ,mobile_number_book
    ,booking_office_contact_name
    ,bank_details
    ,b2b
    ,convenience_charge
    ,convenience_charge_type
    ,facility
    ,keywords
    ,iskeyword
    ,note1
    ,note2
    ,metadesc
    ,metakey_tariff
    ,metadesc_tariff
    ,metakey_contact
    ,metadesc_contact
    ,metakey_enquiry
    ,metadesc_enquiry
    ,highlights
    ,special_notes
    ,delete_status
   } = hotelData;

  const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}hotel/${id}`;
  console.log("api_url", apiUrl);

  const navigate = useNavigate();

  useEffect(() => {
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          navigate('/404'); // <-- Redirect to 404 page
        } else {
          setHotelData(data); // normal case
        }
      })
      .catch(error => {
        console.error(error);
        navigate('/404'); // <-- Optional: redirect on fetch error too
      });
  }, [apiUrl, navigate]);

  let refined_url = name ? name.toLowerCase().replace(/\s+/g, '-') : '';

  const cleanedShortDescription = short_description ? short_description.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ') : "";

  const cleanedDescription = description ? description
  .replace(/<p[^>]*>/g, '<p>')
  .replace(/<\/p[^>]*>/g, '</p>')
  .replace(/<(?!\/?(p|br)\b)[^>]+>/g, '')
  .replace(/&nbsp;/g, ' ') : "";


  const [thumbImagesGallery, setThumbImagesGallery] = useState([]);
  useEffect(() => {
    const imageAPIURLGallery =  `${process.env.REACT_APP_API_ENDPOINT}image_retrieve?id=${id}&image_type=gallery&site_category=hotel`;
    console.log("imageAPIURLGallery: ", imageAPIURLGallery);
    fetch(imageAPIURLGallery)
      .then(response => response.json())
      .then(data => setThumbImagesGallery(data))
      .catch(errorGallery => console.errorGallery(errorGallery));
  }, []);

  
  const [thumbImages, setThumbImages] = useState([]);

  useEffect(() => {
    const imageAPIURL =  `${process.env.REACT_APP_API_ENDPOINT}image_retrieve?id=${id}&image_type=thumb&site_category=hotel`;
    fetch(imageAPIURL)
      .then(response => response.json())
      .then(data => setThumbImages(data))
      .catch(error => console.error(error));
  }, []);

  const [cityState, setCityState] = useState([]);

  useEffect(() => {
    if (city) {
      const cityStateAPIURL =  `${process.env.REACT_APP_API_ENDPOINT}cities?city_id=${city}`;
      console.log("cityStateAPIURL: ", cityStateAPIURL);
      fetch(cityStateAPIURL)
        .then(response => response.json())
        .then(data => setCityState(data))
        .catch(error => console.error(error));
    }
  }, [city]);


  let oldImage;
  if(hotel_image == ''){
    oldImage = 0;    
  } else{
    oldImage = 1;
  }
  //console.log("oldImage: ", oldImage);

  const [highlightsFetch, setHighlightsFetch] = useState([]);

  useEffect(() => {
      const highlightsUrl = `${process.env.REACT_APP_API_ENDPOINT}highlights_list`;
      fetch(highlightsUrl)
        .then(response => response.json())
        .then(data => setHighlightsFetch(data))
        .catch(error => console.log(error));
    }, []);

  const [checkedHighlights, setCheckedHighlights] = useState([]);

  useEffect(() => {
      if (highlights) {
          const highlightIds = highlights.split(',');
          setCheckedHighlights(highlightIds);
      }
  }, [highlights]);


  /*
  const [hotels, setHotels] = useState([]);

  useEffect(() => {
    if (hoteles) {
      const hotelsUrl = `${process.env.REACT_APP_API_ENDPOINT}hotel_listings?id=${hoteles}`;
      //console.log("hotelsUrl: ", hotelsUrl);
      fetch(hotelsUrl)
        .then(response => response.json())
        .then(data => setHotels(data))
        .catch(error => console.error(error));
    }
  }, [hoteles]);
  
  
  console.log("temples: ", temples);
  */

  console.log("city: ", city);

  const [templesList, setTemplesList] = useState([]);
  const [attractionsList, setAttractionsList] = useState([]);
  const [eateriesList, setEateriesList] = useState([]);

  useEffect(() => {

    const templesUrl = city ? `${process.env.REACT_APP_API_ENDPOINT}similar_items?city_id=${city}&item=temples&neglect=0` : '';
      console.log("templesUrl: ", templesUrl);
      const getTemplesList = async () => {
        try {
          const response = await fetch(templesUrl);
          const data = await response.json();
          setTemplesList(data);
        } catch (error) {
          console.error(error);
        }
    };

    const attractionsUrl = city ? `${process.env.REACT_APP_API_ENDPOINT}attractions_eateries?page=1&cat=attraction&city_id=${city}` : '';
      console.log("attractionsUrl: ", attractionsUrl);
      const getAttractionsList = async () => {
        try {
          const response = await fetch(attractionsUrl);
          const data = await response.json();
          setAttractionsList(data);
        } catch (error) {
          console.error(error);
        }
    };
    
    const eateriesUrl = city ? `${process.env.REACT_APP_API_ENDPOINT}attractions_eateries?page=1&cat=eatery&city_id=${city}` : '';
    console.log("eateriesUrl: ", eateriesUrl);
    const getEateriesList = async () => {
      try {
        const response = await fetch(eateriesUrl);
        const data = await response.json();
        setEateriesList(data);
      } catch (error) {
        console.error(error);
      }
    };

    getTemplesList();
    getAttractionsList();
    getEateriesList();
  }, [city]);
    
    //console.log("parent_id: ", parent_id);
    const [hotelTypes, setHotelTypes] = useState([]);
    useEffect(() => {
        const hotelTypesUrl = `${process.env.REACT_APP_API_ENDPOINT}hotel_types/${id}`;
        console.log("hotelTypesUrl: ", hotelTypesUrl);
        fetch(hotelTypesUrl)
          .then(response => response.json())
          .then(data => setHotelTypes(data))
          .catch(error => console.error(error));
    }, [id]);


    const [similarHotels, setSimilarHotels] = useState([]);
    useEffect(() => {
        const similarHotelsUrl = `${process.env.REACT_APP_API_ENDPOINT}similar_items?city_id=${city}&item=hotels&neglect=${id}`;
        console.log("similarHotelsUrl: ", similarHotelsUrl);
        fetch(similarHotelsUrl)
          .then(response => response.json())
          .then(data => setSimilarHotels(data))
          .catch(error => console.error(error));
    }, [id, city]);

    //console.log("tourPlans: ", tourPlans);


    const [open, setOpen] = React.useState(false);

    const [openRoomTypes, setOpenRoomTypes] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [lightboxSlides, setLightboxSlides] = useState([]);

    const handleThumbnailClick = (roomId) => {
      const slidesForRoom = thumbImagesGallery
        .filter((image) => Number(image.room_type) === roomId)
        .map((filteredImage) => ({
          src: filteredImage.hotel_image.includes('aim_')
            ? `/img/uploads/hotels/roomgallery/${filteredImage.hotel_image}`
            : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${filteredImage.hotel_image}`,
          description: filteredImage.name,
        }));

      setLightboxIndex(0); // Reset the index when opening the lightbox
      setLightboxSlides(slidesForRoom);
      setOpenRoomTypes(true);
    };
  


    const [checkInDate, setCheckInDate] = useState('');
  const [checkOutDate, setCheckOutDate] = useState('');
  const [numAdults, setNumAdults] = useState(2);
  const [numChildren, setNumChildren] = useState(0);
  const [numRooms, setNumRooms] = useState(1);
  const [roomType, setRoomType] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    const currentDate = new Date();
    const defaultCheckInDate = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000);
    const defaultCheckOutDate = new Date(currentDate.getTime() + 4 * 24 * 60 * 60 * 1000);

    setCheckInDate(defaultCheckInDate.toISOString().split('T')[0]);
    setCheckOutDate(defaultCheckOutDate.toISOString().split('T')[0]);
  }, []);

  useEffect(() => {
    calculateTotalCost();
  }, [checkInDate, checkOutDate, numAdults, numChildren, numRooms, roomType]);

  useEffect(() => {
    if (hotelTypes.length > 0) {
      setRoomType(hotelTypes[0]?.room_type);
    }
  }, [hotelTypes]);

  const handleCheckInDate = (e) => {
    setCheckInDate(e.target.value);
  };

  const handleCheckOutDate = (e) => {
    setCheckOutDate(e.target.value);
  };

  const handleNumChildrenChange = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 0) {
      setNumChildren(value);
    }
  };

  const handleNumAdultsChange = (e) => {
    const adults = parseInt(e.target.value);
    const maxAdults = numRooms * 4; // Maximum adults allowed in the selected number of rooms
  
    if (adults <= maxAdults) {
      setNumAdults(adults);
    } else {
      // If the number of adults exceeds the maximum, adjust the number of rooms accordingly
      setNumAdults(maxAdults);
      setNumRooms(Math.ceil(maxAdults / 4));
    }
  };
  
  const handleNumRoomsChange = (e) => {
    const rooms = parseInt(e.target.value);
    const maxAdults = rooms * 4; // Maximum adults allowed in the selected number of rooms
  
    if (numAdults > maxAdults) {
      setNumAdults(maxAdults);
    }
    if (!isNaN(rooms) && rooms >= 1) {
      setNumRooms(rooms);
    }
  };

  const handleRoomTypeChange = (e) => {
    setRoomType(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform checkout logic here
  };

  const [convenienceChargeAmount, setConvenienceChargeAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [taxPercent, setTaxPercent] = useState(0);
  const [selectedRoomTypePrice, setSelectedRoomTypePrice] = useState(0);

  const calculateTotalCost = () => {
    const selectedRoomType = hotelTypes.find((type) => type.room_type === roomType);
  
    if (selectedRoomType && checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const numNights = Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24)); // Use Math.ceil to round up to the nearest whole night
  
      const basePrice = selectedRoomType.price;
      setSelectedRoomTypePrice(basePrice);
      const extraPersonCharge = selectedRoomType.extra_person_charge;
      const tax = selectedRoomType.tax;
      setTaxPercent(tax);
  
      const totalBaseCost = basePrice * numRooms * numNights;
      const totalExtraPersonCost = extraPersonCharge * Math.max(numAdults - 2, 0) + extraPersonCharge * Math.max(numChildren - 1, 0); // Update calculation for extra person cost
      const totalCost = totalBaseCost + totalExtraPersonCost;
      console.log("totalCost: ", totalCost);
      setSelectedRoomTypePrice(totalCost);
  
      const taxAmount = (totalCost * tax) / 100;
      setTaxAmount(taxAmount);
      let totalCostWithTax = totalCost + taxAmount;

      // Addition of convenience fee
      if(convenience_charge_type === 'rupees'){
        totalCostWithTax = parseFloat(totalCostWithTax) + parseFloat(convenience_charge);
        setConvenienceChargeAmount(parseFloat(convenience_charge));
      } else if (convenience_charge_type === 'percentage') {
        const convenienceChargeAmount = (parseFloat(convenience_charge) * parseFloat(totalCost)) / 100;
        totalCostWithTax += convenienceChargeAmount;
        setConvenienceChargeAmount(convenienceChargeAmount);
      }
  
      setTotalPrice(totalCostWithTax);
    }
  };     


const [showTooltip, setShowTooltip] = useState(false);

const toggleTooltip = () => {
  setShowTooltip(!showTooltip);
};

const mealTypesLabels = ['European Plan', 'American Plan', 'Modified American Plan', 'Continental Plan'];

const getMealTypeLabel = (mealTypes) => {
  if (mealTypes) {
    const mealTypeIndices = mealTypes.split(',');
    for (let i = 0; i < mealTypeIndices.length; i++) {
      if (mealTypeIndices[i] > 0) {
        return mealTypesLabels[i];
      }
    }
  }
  return '';
};



const handleCheckout = () => {

  const newItem = {
      id: id,
      checkInDate: checkInDate,
      checkOutDate: checkOutDate,
      category: 'hotel',
      numAdults: numAdults,
      numChildren: numChildren,
      numRooms: numRooms,
      roomType: roomType,
      selectedRoomTypePrice: selectedRoomTypePrice,
      taxAmount: taxAmount,
      convenienceChargeAmount: convenienceChargeAmount,
      totalPrice: totalPrice
  };

  // Retrieve existing cart items from local storage or initialize an empty array
  const existingItems = JSON.parse(localStorage.getItem('cartItems')) || [];

  // Add the new item to the existing array of cart items
  const updatedItems = [...existingItems, newItem];

  // Store the updated array back into local storage
  localStorage.setItem('cartItems', JSON.stringify(updatedItems));

  window.location.href = "/cart";
};



const [formData, setFormData] = useState({
  fullName: '',
  email: '',
  mobileNumber: '',
  noOfPersons: '',
  hotelType: '',
  startDate: '',
  endDate: '',
  message: '',
  graduationDay: ''
});
const [isSubmitted, setIsSubmitted] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleEnquirySubmit = (e) => {
  e.preventDefault();

  if (formData.graduationDay !== '') {
    // A value is present in the honeypot field, likely a bot
    return;
  }

  if (
    formData.fullName.trim() === '' ||
    formData.email.trim() === '' ||
    formData.mobileNumber.trim() === '' ||
    formData.noOfPersons.trim() === ''
  ) {
    alert('Please fill in all required fields.');
  } else {
    // Prepare the form data for submission
    const data = {
      fullName: formData.fullName,
      email: formData.email,
      mobileNumber: formData.mobileNumber,
      noOfPersons: formData.noOfPersons,      
      hotelType: '',
      startDate: formData.startDate,
      endDate: formData.endDate,
      message: formData.message,
      website: 'Blessingsonthenet.com',
      page_title: name
    };

    console.log("enquiry data: ", data);

    // Replace 'your-api-endpoint' with your actual API endpoint
    fetch(`${process.env.REACT_APP_API_ENDPOINT}enquiry_submission`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          // Handle a successful response here
          setIsSubmitted(true);
        } else {
          // Handle errors here
          console.error('Form submission failed');
        }
      })
      .catch((error) => {
        console.error('Error submitting the form:', error);
      });
  }
};



// Function to scroll to an element
const scrollToElement = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

// Get the current URL
const currentURL = window.location.pathname;

// Define a regex pattern to match URLs
const roomTypePattern = /^\/hotels\/room-type\/(.+?)\/(\d+)$/;
const contactInfoPattern = /^\/hotels\/contactinfo\/(.+?)\/(\d+)$/;
const facilityPattern = /^\/hotels\/facility\/(.+?)\/(.+?)\/(\d+)$/;
const enquiryPattern = /^\/hotels\/accommodation-enquiry\/(.+?)\/(\d+)$/;

// Check if the URL matches the room type pattern
const roomTypeMatch = currentURL.match(roomTypePattern);
if (roomTypeMatch) {
  scrollToElement(`rooms`);
}

// Check if the URL matches the contact info pattern
const contactInfoMatch = currentURL.match(contactInfoPattern);
if (contactInfoMatch) {
  scrollToElement(`accommodation-enquiry`);
}

const facilityMatch = currentURL.match(facilityPattern);
if (facilityMatch) {
  scrollToElement(`facility`);
}

const enquiryMatch = currentURL.match(enquiryPattern);
if (enquiryMatch) {
  scrollToElement(`accommodation-enquiry`);
}

// Calculate the minimum selectable date (2 days from today)
const checkInToday = new Date();
checkInToday.setDate(checkInToday.getDate() + 2);
const minCheckInDate = checkInToday.toISOString().split('T')[0];

const checkOutToday = new Date();
checkOutToday.setDate(checkOutToday.getDate() + 3);
const minCheckOutDate = checkOutToday.toISOString().split('T')[0];


//Popup Form
const [showPopupForm, setshowPopupForm] = useState(false);

useEffect(() => {
  const timeout = setTimeout(() => {
    // Check if the popup was previously closed within the last 24 hours
    const popupClosedTime = localStorage.getItem('popupHotelClosedTime');
    if (popupClosedTime) {
      const now = new Date().getTime();
      const elapsedTime = now - parseInt(popupClosedTime);
      if (elapsedTime >= 12 * 60 * 60 * 1000) {
        // If more than 12 hours have passed since the popup was closed, show it again
        setshowPopupForm(true);
      }
    } else {
      // If the popup has not been closed before, show it after 20 seconds
      setshowPopupForm(true);
    }
  }, 20000);

  return () => clearTimeout(timeout);
}, []);

const handleClosePopup = () => {
  setshowPopupForm(false);
  // Store in local storage that the user has closed the popup
  localStorage.setItem('popupHotelClosed', 'true');
  // Store the time when the popup was closed
  const now = new Date().getTime();
  localStorage.setItem('popupHotelClosedTime', now.toString());
};

function openPopup() {
  setshowPopupForm(true);
}

  return (
    <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>{`${name} | Blessingsonthenet.com`}</title>
    </Helmet>

    {showPopupForm && (
        <div className="position-fixed top-0 bottom-0 d-flex justify-content-center align-items-center w-75 popup_form">
          <div className="px-40 pt-35 pb-40 lg:px-30 lg:py-30 md:px-24 md:py-24 bg-white rounded-4 shadow-4">
              <div className="text-22 fw-500">Explore Our Exclusive Hotel Deals!</div>
                <small>Fill your details below and we'll call you in a while.</small>
                <button type="button" className="close popup_form_close" aria-label="Close" onClick={handleClosePopup}>
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="row y-gap-15 pt-20">
                  <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="form-input">
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">Full Name*</label>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="form-input">
                      <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">Email Address*</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="text"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">Mobile Number*</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="text"
                        name="noOfPersons"
                        value={formData.noOfPersons}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">No. of Person*</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        min={minCheckInDate}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1" style={{top:'15px'}}>Start Date</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        min={minCheckOutDate}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1" style={{top:'15px'}}>End Date</label>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="form-input">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="1"
                      ></textarea>
                      <label className="lh-1 text-16 text-light-1">Message (If Any)</label>
                    </div>
                  </div>
                  <div style={{ display: 'none' }}>
                    <input
                      type="text"
                      name="graduationDay"
                      value={formData.graduationDay}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-auto">
                    <button
                      onClick={handleEnquirySubmit}
                      className="button px-24 h-50 -dark-1 bg-blue-1 text-white"
                    >
                      Get a Callback
                      <div className="icon-arrow-top-right ml-15"></div>
                    </button>
                  </div>
                  <div className="col-12">
                    {isSubmitted && <p style={{color:'green'}}>Thanks for submitting your details, we will get back to you shortly!</p>}
                  </div>
                </div>
            </div>
        </div>
    )}

    <div class="floating-section">
        <div class="floating-option">
          <a style={{cursor:'pointer'}} onClick={openPopup}>
            <img src={`/assets/img/general/telephone.png`} />
            Get a Callback
          </a>
        </div>
        <div class="floating-option">
            <a href="https://wa.me/919224444455" target="_blank" rel="noopener noreferrer">
              <img src={`/assets/img/general/whatsapp.png`} />
              Chat on WhatsApp
            </a>
        </div>
    </div>

    <div class="mt-35">
      <HeaderSearch />

      <section class="py-10 d-flex items-center bg-light-2">
        <div class="container">
          <div class="row y-gap-10 items-center justify-between">
            <div class="col-auto">
              <div class="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                <div class="col-auto">
                  <div class="">Home</div>
                </div>
                <div class="col-auto">
                  <div class="">&gt;</div>
                </div>
                <div class="col-auto">
                  <div class="">Hotels</div>
                </div>
                <div class="col-auto">
                  <div class="">&gt;</div>
                </div>
                <div class="col-auto">
                  <div class="text-dark-1">{name}</div>
                </div>
              </div>
            </div>

            <div class="col-auto">
              {/*<a href="#" class="text-14 text-blue-1 underline">View Hotels Involving Dwarka</a>*/}
            </div>
          </div>
        </div>
      </section>

      <section class="pt-40">
        <div class="container">
          <div class="row y-gap-20 justify-between items-end">
            <div class="col-auto">
              <div class="row x-gap-20  items-center">
                <div class="col-auto">
                  <h1 class="text-30 sm:text-25 fw-600" style={{maxWidth:750,}}>{name}</h1>
                </div>
                <div class="col-auto">

                  <i class="icon-star text-10 text-yellow-1"></i>

                  <i class="icon-star text-10 text-yellow-1"></i>

                  <i class="icon-star text-10 text-yellow-1"></i>

                  <i class="icon-star text-10 text-yellow-1"></i>

                  <i class="icon-star text-10 text-yellow-1"></i>

                </div>
              </div>

              <div class="row x-gap-20 y-gap-20 items-center">
                <div class="col-auto">
                  <div class="d-flex items-center text-15 text-light-1">
                    {cityState.length > 0 && `${cityState[0].city}, ${cityState[0].state}`} (<b>{star_rating} Star Hotel</b>)
                  </div>
                </div>
              </div>
            </div>

            <div class="col-auto">
              <div class="row x-gap-15 y-gap-15 items-center">
                <div class="col-auto">
                  <div class="text-14">
                  {price !== null && price !== '0' ? (
                    <>
                      Price Starts From{' '}
                      <span className="text-22 text-dark-1 fw-500">₹{price}</span>
                    </>
                  ) : (
                    <a onClick={openPopup} style={{cursor:'pointer'}} class="button h-50 px-24 -dark-1 bg-blue-1 text-white">
                      Contact Us
                    </a>
                  )}
                  </div>
                </div>
                
                {price !== null && price !== '0' ? (
                <div class="col-auto">
                  <a href="#book-now" class="button h-50 px-24 -dark-1 bg-blue-1 text-white">
                    Book Now <div class="icon-arrow-top-right ml-15"></div>
                  </a>
                </div>
                ) : ''}


              </div>
            </div>
          </div>

          <div class="galleryGrid -type-1 pt-30">
            {/*
            {oldImage == 1 ? (
                    <div className="galleryGrid__item">
                        <img
                        style={{height:'unset'}}
                        src={`/img/uploads/hotel/${hotel_image}`}
                        alt="image"
                        className="rounded-4"
                        />
                    </div>
                ) : (
                null
            )}
            */}
            {thumbImagesGallery.length > 0 ? (
              thumbImagesGallery.slice(0, 4).map((image, index) => (
                <div className="galleryGrid__item" key={index}>
                  <img
                    src={image.hotel_image.includes('aim_')
                    ? `/img/uploads/hotels/roomgallery/${image.hotel_image}`
                    : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${image.hotel_image}`}
                    alt="image"
                    className="rounded-4"
                    onClick={() => setOpen(true)}
                  />
                </div>
              ))
            ) : (
              //Showing old images if no gallery images exits
              <div className="galleryGrid__item">
                <img
                  src={`/img/uploads/hotels/roomgallery/${hotel_image}`}
                  alt="image"
                  className="rounded-4"
                  onClick={() => setOpen(true)}
                />
              </div>
            )}

            {thumbImages.length > 0 ? (
                thumbImages.slice(0, 1).map((image, index) => (
                    <div className="galleryGrid__item relative d-flex" key={index}>
                        <img
                        src={image.hotel_image.includes('aim_')
                        ? `/img/uploads/hotels/roomgallery/${image.hotel_image}`
                        : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${image.hotel_image}`}
                        alt="image"
                        className="rounded-4"
                        />
                        <div class="absolute px-10 py-10 col-12 h-full d-flex justify-end items-end">
                        <button type="button" onClick={() => setOpen(true)} className="button -blue-1 px-24 py-15 bg-white text-dark-1 js-gallery">
                          See All Photos
                        </button>
                          <Lightbox
                            plugins={[Captions]}
                            open={open}
                            close={() => setOpen(false)}
                            slides={thumbImagesGallery.map((image) => ({ src: `${image.hotel_image.includes('aim_') ? `/img/uploads/hotels/roomgallery/${image.hotel_image}` : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${image.hotel_image}`}`, description: image.name }))}
                          />

                          {/* Specific room types */}
                          <Lightbox
                            plugins={[Captions]}
                            open={openRoomTypes}
                            close={() => setOpenRoomTypes(false)}
                            currentIndex={lightboxIndex}
                            slides={lightboxSlides}
                          />
                        </div>
                    </div>
                ))
                ) : (
                null
            )}
          </div>
        </div>
      </section>

      <section class="pt-30">
        <div class="container">
          <div class="row y-gap-30">
            <div class="col-xl-8">
              <div class="row y-gap-40 dark_text">
                <div class="col-12">
                  <h3 id="facility" class="text-22 fw-500">Property Highlights</h3>
                  <div class="row y-gap-20 pt-30">

                    <div class="col-lg-3 col-6">
                      <div class="text-center">
                        <i class="icon-city text-24 text-blue-1"></i>
                        <div class="text-15 lh-1 mt-10">City Centre</div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-6">
                      <div class="text-center">
                        <i class="icon-airplane text-24 text-blue-1"></i>
                        <div class="text-15 lh-1 mt-10">Near to Airport</div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-6">
                      <div class="text-center">
                        <i class="icon-bell-ring text-24 text-blue-1"></i>
                        <div class="text-15 lh-1 mt-10">Front Desk [24-hours]</div>
                      </div>
                    </div>

                    <div class="col-lg-3 col-6">
                      <div class="text-center">
                        <i class="icon-tv text-24 text-blue-1"></i>
                        <div class="text-15 lh-1 mt-10">Premium TV channels</div>
                      </div>
                    </div>

                  {highlightsFetch.map(item => (
                    checkedHighlights.includes(item.id.toString()) && (
                      <div className="col-lg-2 col-6" key={item.id}>
                        <div className="text-center">
                          <i className={`${item.css_class} text-24 text-blue-1`}></i>
                          <div className="text-15 lh-1 mt-10">{item.highlight_name}</div>
                        </div>
                      </div>
                    )
                  ))}

                  </div>
                </div>

                <div id="overview" class="col-12">
                  <h3 class="text-22 fw-500 pt-40 border-top-light">Overview</h3>
                  <p class="text-dark-1 text-15 mt-20">
                    {cleanedShortDescription}
                  </p>
                  {/*<a href="#" class="d-block text-14 text-blue-1 fw-500 underline mt-10">Show More</a>*/}
                </div>

                <div class="col-12">
                  <h3 class="text-22 fw-500 pt-40 border-top-light">Specifications</h3><br />
                  {/*<div dangerouslySetInnerHTML={{ __html: cleanedDescription }} />*/}
                  <div dangerouslySetInnerHTML={{ __html: description }} />               
                </div>

              </div>
            </div>

            <div class="col-xl-4">

              <div class="ml-50 lg:ml-0" style={{marginBottom:'20px'}}>
                  <div class="px-30 pt-20 pb-20 border-light rounded-4 shadow-4" id="book-now">
                      <div class="sidebar__item" style={{borderTop:'none'}}>
                          <h5 class="text-20 fw-500 mb-10">Quick Links</h5>
                          <div class="sidebar-checkbox">
                              <table class="table-4 w-1/1 blessings_categories">
                                  <tbody>
                                      <tr>
                                          <td>    
                                              <a href={`/hotel/${refined_url}/${id}`}>
                                                  <img src={`/assets/img/general/categories-arrow.png`} />
                                                  Overview
                                              </a>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>    
                                              <a href={`/hotels/facility/${refined_url}/${cityState[0]?.city}/${id}`}>
                                                  <img src={`/assets/img/general/categories-arrow.png`} />
                                                  Facilities
                                              </a>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>    
                                              <a href={`/hotels/room-type/${refined_url}/${id}`}>
                                                  <img src={`/assets/img/general/categories-arrow.png`} />
                                                  Room Types
                                              </a>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>    
                                              <a href={`/hotels/contactinfo/${refined_url}/${id}`}>
                                                  <img src={`/assets/img/general/categories-arrow.png`} />
                                                  Contact Details/Map
                                              </a>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>    
                                              <a href={`/hotels/accommodation-enquiry/${refined_url}/${id}`}>
                                                  <img src={`/assets/img/general/categories-arrow.png`} />
                                                  Accommodation Enquiry
                                              </a>
                                          </td>
                                      </tr>

                                      
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="ml-50 lg:ml-0">

                <div class="px-30 pt-20 pb-20 border-light rounded-4 shadow-4" id="book-now">
                  <div class="d-flex items-center justify-between">
                    <div class="">
                      <span class="text-20 fw-500">Book Now</span>
                    </div>
                  </div>
                  
                  {!isNaN(price) && price > 0 ? (
                  <div class="row y-gap-20 pt-10">
                      <div className="col-12">
                        <div className="px-20 py-10 border-light rounded-4 -right">
                          <div>
                            <h4 className="text-15 fw-500 ls-2 lh-16">Check in Date</h4>
                            <div className="text-15 text-light-1 ls-2 lh-16">
                              <span className="js-first-date">
                                <input type="date" id="checkInDate" value={checkInDate} min={minCheckInDate} onChange={handleCheckInDate} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="px-20 py-10 border-light rounded-4 -right">
                          <div>
                            <h4 className="text-15 fw-500 ls-2 lh-16">Check out Date</h4>
                            <div className="text-15 text-light-1 ls-2 lh-16">
                              <span className="js-first-date">
                                <input type="date" id="checkOutDate" value={checkOutDate} min={minCheckOutDate} onChange={handleCheckOutDate} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className={`row px-20 py-10 border-light rounded-4 room_input`}>

                          <div className='col-4'>
                            <h4 className="text-15 fw-500 ls-2 lh-16">Adults</h4>
                            <div className="text-15 text-light-1 ls-2 lh-16">
                              <span><input type="number" id="numAdults" value={isNaN(numAdults) ? '' : numAdults} min={1} onChange={handleNumAdultsChange} /></span>
                            </div>
                          </div>

                          <div className='col-4'>
                            <h4 className="text-15 fw-500 ls-2 lh-16">Children</h4>
                            <div className="text-15 text-light-1 ls-2 lh-16">
                              <span><input type="number" id="numChildren" value={isNaN(numChildren) ? '' : numChildren} min={0} onChange={handleNumChildrenChange} /></span>
                            </div>
                          </div>

                          <div className='col-4'>
                            <h4 className="text-15 fw-500 ls-2 lh-16">Rooms</h4>
                            <div className="text-15 text-light-1 ls-2 lh-16">
                              <span><input type="number" id="numRooms" value={isNaN(numRooms) ? '' : numRooms} min={1} onChange={handleNumRoomsChange} /></span>
                            </div>
                          </div>

                          <div className={`tooltip_booking ${showTooltip ? 'tooltip-disabled' : 'tooltip-active'}`}>
                            <button className="close-button" onClick={toggleTooltip}>
                              x
                            </button>
                            <p>
                              <b>Important Notes:</b>
                            </p>
                            <ul>
                              <li>Kids below 5 years old are complimentary</li>
                              <li>Kids between 6 to 10 years will be considered as children</li>
                              <li>Kids more than 10 years old will be considered as adults</li>
                            </ul>
                          </div>
                        </div>

                        <div className="row px-20 pt-10 border-light rounded-4 mt-20 room_input">
                          <div>
                            <h4 className="text-15 fw-500 ls-2 lh-16">Room Type</h4>
                            <div className="text-15 text-light-1 ls-2 lh-16">
                              <select className="hotel_select_tag" id="roomType" value={roomType} onChange={handleRoomTypeChange}>
                                {hotelTypes.length > 0 &&
                                  hotelTypes.map((page) => (
                                    <option key={page.room_type} value={page.room_type}>
                                      {page.room_type}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="text-center mt-10 row">
                          <span class="text-14 text-light-1 text-left col-6">Sub-Total: </span>
                          <span class="text-15 fw-500 text-right col-6">₹{selectedRoomTypePrice}</span>
                        </div>

                        {taxAmount > 0 && (
                          <div className="text-center row">
                            <span className="text-14 text-light-1 text-left col-6">GST ({taxPercent}%)</span>
                            <span className="text-15 fw-500 text-right col-6">₹{taxAmount}</span>
                          </div>
                        )}

                        {convenienceChargeAmount > 0 && (
                        <div className="text-center row">
                          <span class="text-14 text-light-1 text-left col-6">Convenience Fee: </span>
                          <span class="text-15 fw-500 text-right col-6">₹{convenienceChargeAmount}</span>
                        </div>
                        )}

                        <div className="text-center mt-10 row">
                          <span class="text-14 text-light-1 text-left col-6">Total Price: </span>
                          <span class="text-20 fw-500 text-right col-6">₹{totalPrice}</span>
                        </div>

                      </div>

                      <div class="col-12">
                        <button type="submit" class="button -dark-1 px-35 h-60 col-12 bg-blue-1 text-white" onClick={handleCheckout}>
                          Checkout
                        </button>
                      </div>

                      <div class="col-12">
                        <button onClick={openPopup} style={{cursor:'pointer'}} class="button -blue-1 px-35 h-60 col-12 -outline-blue-1 text-blue-1">Customize Hotel</button>
                      </div>

                  </div>
                  ) : (<div className="text-center">
                    <br />
                    <h6 style={{color:'#FF0000'}}>Contact for Immediate Response</h6>
                    <br />
                    {/*
                    <a href="https://wa.me/918452040404">+91 8452 040 404</a><br />
                    <a href="https://wa.me/919224444455">+91 9224 444 455</a>
                    */}
                    <a href="https://wa.me/918452040404">+91 8452 040 404</a><br />
                    <a href="https://wa.me/919224444455">+91 9224 444 455</a>
                    <br /><br />
                    <h6 style={{color:'#FF0000'}}>Send Us Email</h6>
                    <a href="mailto:travel@blessingsonthenet.com">travel@blessingsonthenet.com</a><br /><br />
                    </div>)
                  }

                </div>

                {cityState.length > 0 && (
                  <>
                    {(cityState[0].city === "Mahabaleshwar" || cityState[0].city === "Panchgani") && (
                      <a target="_blank" href="/hotel/valley-haven-resort-mahableshwar/4917">
                        <img
                          src="https://api.blessingsonthenet.com/uploads/featured/valley-haven.jpeg"
                          alt="Valley Haven"
                          style={{ marginTop: '20px' }} // optional styling
                        />
                      </a>
                    )}
                  </>
                )}

              </div>
            </div>
          </div>
        </div>
      </section>
   

      <section id="rooms" class="pt-50">
        <div class="container">
          <div class="row pb-20">
            <div class="col-auto">
              <h3 class="text-22 fw-500">Room Types</h3>
            </div>
          </div>
          
          {hotelTypes.length > 0 && hotelTypes.map((page) => (
            <div class="border-light rounded-4 px-30 py-30 sm:px-20 sm:py-20" style={{marginBottom:'20px'}}>
            <div class="row y-gap-20">
              <div class="col-12">
              <h3 class="text-18 fw-500 mb-15">{page.room_type}</h3>
              <div class="roomGrid">
                <div class="roomGrid__header">
                <div>Room Type</div>
                <div>Benefits</div>
                <div>Members</div>
                <div>Price for 1 Night</div>
                <div></div>
                </div>

                <div class="roomGrid__grid">
                <div>
                  <div key={page.id} class="ratio ratio-1:1">

                  {thumbImagesGallery
                    .slice(0, 1)
                    .map((image, index) => (
                      <div key={index}>
                        <img
                          src={
                            image.hotel_image.includes('aim_')
                              ? `/img/uploads/hotels/roomgallery/${image.hotel_image}`
                              : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${image.hotel_image}`
                          }
                          alt="image"
                          className="img-ratio rounded-4"
                          onClick={() => setOpen(true)}
                        />
                      </div>
                    ))
                  }

                  {thumbImagesGallery
                    .filter((image) => image.room_type !== null && Number(image.room_type) === page.id)
                    .slice(0, 1)
                    .map((filteredImage, index) => (
                      <div key={index} onClick={() => handleThumbnailClick(page.id)}>
                        <img
                          src={
                            filteredImage.hotel_image.includes('aim_')
                              ? `/img/uploads/hotels/roomgallery/${filteredImage.hotel_image}`
                              : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${filteredImage.hotel_image}`
                          }
                          alt="image"
                          className="img-ratio rounded-4"
                        />
                      </div>
                    ))
                  }
                  

                  </div>

                  <div class="y-gap-5 mt-20">
                  {getMealTypeLabel(page.meal_types) && (
                    <div class="d-flex items-center">
                    <i class="icon-food text-20 mr-10"></i>
                    <div class="text-15">{getMealTypeLabel(page.meal_types)}</div>
                    </div>
                  )}
                  </div>
            
                  {/*
                  <div class="y-gap-5 mt-20">

                  <div class="d-flex items-center">
                    <i class="icon-no-smoke text-20 mr-10"></i>
                    <div class="text-15">{page.other_facility} Non-smoking rooms</div>
                  </div>

                  <div class="d-flex items-center">
                    <i class="icon-wifi text-20 mr-10"></i>
                    <div class="text-15">Free WiFi</div>
                  </div>

                  <div class="d-flex items-center">
                    <i class="icon-parking text-20 mr-10"></i>
                    <div class="text-15">Parking</div>
                  </div>

                  <div class="d-flex items-center">
                    <i class="icon-kitchen text-20 mr-10"></i>
                    <div class="text-15">Kitchen</div>
                  </div>

                  </div>
                  */}
                </div>

                <div class="y-gap-30">

                  <div class="roomGrid__content">
                  <div>

                    <div class="y-gap-8">

                    <div>
                      {page.available_facility && page.available_facility.trim() !== '' && (
                      page.available_facility.split(',').map((item, index) => (
                        <div className="d-flex items-center text-green-2" key={index}>
                        <i className="icon-check text-12 mr-10"></i>
                        <div className="text-15">{item.trim()}</div>
                        </div>
                      ))
                      )}

                      {page.other_facility && page.other_facility.trim() !== '' && (
                      page.other_facility.split(',').map((item, index) => (
                        <div className="d-flex items-center text-green-2" key={index}>
                        <i className="icon-check text-12 mr-10"></i>
                        <div className="text-15">{item.trim()}</div>
                        </div>
                      ))
                      )}
                    </div>

                    </div>
                  </div>

                  <div>
                    <div class="d-flex items-center text-light-1">
                    <div class="icon-man text-24"></div>
                    <div class="icon-man text-24"></div>
                    </div>
                  </div>

                  <div>
                    <div class="text-18 lh-15 fw-500">₹{page.price}</div>
                    <div class="text-14 lh-18 text-light-1">{page.tax}% tax extra</div>
                  </div>
                  </div>

                  {page.description.length > 0 && (
                  <div class="y-gap-5 grey_border_top">
                  <div dangerouslySetInnerHTML={{ __html: page.description }} />
                  </div>
                  )}

                </div>

                <div>
                  <div class="text-14 lh-1">1 Room (accomodates 2 people)</div>
                  <div class="text-22 fw-500 lh-17 mt-5">₹{page.price}</div>


                  <a onClick={openPopup} style={{cursor:'pointer'}} class="button h-50 px-24 -dark-1 bg-blue-1 text-white mt-10">
                  Book Now <div class="icon-arrow-top-right ml-15"></div>
                  </a>


                  <div class="text-15 fw-500 mt-30">Additional People Cost</div>

                  <ul class="list-disc y-gap-4 pt-5">

                  <li class="text-14">Extra Person: ₹{page.extra_person_charge ? page.extra_person_charge : 0}</li>

                  <li class="text-14">Child: ₹{page.child_price ? page.child_price : 0}</li>

                  </ul>
                </div>
                </div>
              </div>
              </div>
            </div>
            </div>
          ))}
          
        </div>
      </section>
                      
      {special_notes && (
      <section class="pt-40">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="px-24 py-20 rounded-4 bg-light-2">
                <div class="row x-gap-20 y-gap-20 items-center">
                  <div class="col-auto">
                    <div class="flex-center size-60 rounded-full bg-white">
                      <img src="/assets/img/icons/health.svg" alt="icon" />
                    </div>
                  </div>

                  <div class="col-auto">
                    <h4 class="text-18 lh-15 fw-500">Special Notes</h4>
                      <div className="text-15 lh-15" dangerouslySetInnerHTML={{ __html: special_notes }} />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      )}

    <section id="accommodation-enquiry" class="layout-pt-lg layout-pb-md pt-80">
      <div data-anim-wrap="" class="container animated">
        <div data-anim-child="slide-up delay-1" class="row justify-center text-center is-in-view">
          <div class="col-auto">
            <div class="sectionTitle -md">
              <h2 class="sectionTitle__title">Enquire with Us</h2>
              <p class=" sectionTitle__text mt-20 sm:mt-0"><b>Hotel Address:</b> <span dangerouslySetInnerHTML={{ __html: address }} /></p>
              <p>Call Us for Enquiry: <b><a href="https://wa.me/919224444455">+91 9224 444 455</a> / <a href="https://wa.me/918452040404">+91 8452 040 404</a></b></p>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <div style={{backgroundColor: '#13357B', color: '#fff',}} class="mt-50 px-40 pt-30 pb-30 lg:px-30 lg:py-30 md:px-24 md:py-24 rounded-4 shadow-4">
                <div class="card-body">
                  <h4 style={{color: '#fff',}} class="card-title">WhatsApp Us</h4><br />
                  <p style={{color: '#fff',}} class="card-text">Request a quote, or just chat about your next vacation. We're always happy to help!</p><br />
                  {/*
                  <a target="_blank" href="https://wa.me/918452040404"><h5 style={{color: '#fff',}} class="card-text mb-10"><img src="/assets/img/icons/phone.png" style={{width:'25px'}} /> +91 8452 040 404</h5></a>
                  <a target="_blank" href="https://wa.me/919224444455"><h5 style={{color: '#fff',}} class="card-text mb-10"><img src="/assets/img/icons/phone.png" style={{width:'25px'}} /> +91 9224 444 455</h5></a>
                  <a target="_blank" href="https://wa.me/919987404440"><h5 style={{color: '#fff',}} class="card-text mb-10"><img src="/assets/img/icons/phone.png" style={{width:'25px'}} /> +91 9987 404 440</h5></a>
                  */}
                  <a target="_blank" href="https://wa.me/918452040404"><h5 style={{color: '#fff',}} class="card-text mb-10"><img src="/assets/img/icons/phone.png" style={{width:'25px'}} /> +91 8452 040 404</h5></a>
                  <a target="_blank" href="https://wa.me/919224444455"><h5 style={{color: '#fff',}} class="card-text mb-10"><img src="/assets/img/icons/phone.png" style={{width:'25px'}} /> +91 9224 444 455</h5></a>
                  <a target="_blank" href="https://wa.me/919987404440"><h5 style={{color: '#fff',}} class="card-text mb-10"><img src="/assets/img/icons/phone.png" style={{width:'25px'}} /> +91 9987 404 440</h5></a>
                </div>
              </div>
              <div style={{backgroundColor: '#ff894c', color:'#051036'}} class="mt-50 px-40 pt-40 pb-50 lg:px-30 lg:py-30 md:px-24 md:py-24 rounded-4 shadow-4">
                <div class="card-body">
                  <h4 style={{color:'#051036'}} class="card-title">Write to Us</h4><br />
                  <p style={{color:'#051036'}} class="card-text">Do you like to customize this hotel stay even more or be it an enquiry, feedback or a simple suggestion, write to us.</p><br />
                  <a target="_blank" href="mailto:travel@blessingsonthenet.com"><h5 style={{color:'#051036'}} class="card-text"><img src="/assets/img/icons/email.png" style={{width:'25px'}} /> travel@blessingsonthenet.com</h5></a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
            <div className="mt-50 px-40 pt-35 pb-40 lg:px-30 lg:py-30 md:px-24 md:py-24 bg-white rounded-4 shadow-4">
              <div className="text-22 fw-500">Enter your journey details for travel enquiry.</div>
                <div className="row y-gap-15 pt-20">
                  <div className="col-12">
                    <div className="form-input">
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">Full Name*</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-input">
                      <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">Email Address*</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="text"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">Mobile Number*</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="text"
                        name="noOfPersons"
                        value={formData.noOfPersons}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1">No. of Person*</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        min={minCheckInDate}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1" style={{top:'15px'}}>Start Date</label>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-input">
                      <input
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        min={minCheckOutDate}
                        onChange={handleChange}
                        required
                      />
                      <label className="lh-1 text-16 text-light-1" style={{top:'15px'}}>End Date</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-input">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="2"
                      ></textarea>
                      <label className="lh-1 text-16 text-light-1">Message (If Any)</label>
                    </div>
                  </div>
                  <div style={{ display: 'none' }}>
                    <input
                      type="text"
                      name="graduationDay"
                      value={formData.graduationDay}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-auto">
                    <button
                      onClick={handleEnquirySubmit}
                      className="button px-24 h-50 -dark-1 bg-blue-1 text-white"
                    >
                      Send a Message
                      <div className="icon-arrow-top-right ml-15"></div>
                    </button>
                  </div>
                  <div className="col-12">
                    {isSubmitted && <p style={{color:'green'}}>Thanks for submitting your details, we will get back to you shortly!</p>}
                  </div>
                </div>
            </div>
            </div>
          </div>
        </div>
        
      </div>
    </section>

      <section class="layout-pt-lg layout-pb-md relative" id="secondSection">
        <div data-anim-wrap="" class="container animated">
          <div data-anim-child="slide-up delay-1" class="row y-gap-20 justify-center text-center is-in-view">
            <div class="col-auto">
              <div class="sectionTitle -md">
                <h2 class="sectionTitle__title">Whats Nearby?</h2>
                <p class=" sectionTitle__text mt-5 sm:mt-0">Here are list of nearby places that you might be intersted in</p>
              </div>
            </div>
          </div>

          <div class="row x-gap-10 y-gap-10 pt-40 sm:pt-20">

            <div data-anim-child="slide-up delay-2" class="col-xl-4 col-lg-3 col-6 is-in-view">
              <a href="#" class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4">
                <img src="/assets/img/icons/temple.png" style={{width:'30px'}} />

                <div class="ml-10 sm:ml-0 sm:mt-10">
                  <h4 class="text-16 fw-500">Temples</h4>
                </div>
              </a>
            </div>

            <div data-anim-child="slide-up delay-3" class="col-xl-4 col-lg-3 col-6 is-in-view">
              <a href="#" class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4">
                <i class="icon-destination text-24"></i>

                <div class="ml-10 sm:ml-0 sm:mt-10">
                  <h4 class="text-16 fw-500">Tourist Attractions</h4>
                </div>
              </a>
            </div>

            <div data-anim-child="slide-up delay-4" class="col-xl-4 col-lg-3 col-6 is-in-view">
              <a href="#" class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4">
                <img src="/assets/img/icons/restaurant.png" style={{width:'30px'}} />

                <div class="ml-10 sm:ml-0 sm:mt-10">
                  <h4 class="text-16 fw-500">Top Eateries/Shopping</h4>
                </div>
              </a>
            </div>

              <div data-anim-child="slide-up delay-2" class="col-xl-4 col-lg-3 col-6 is-in-view">
                {/*
                {templesList.map((temple) => (
                  <a target="_blank" href={`/attractions/${temple.name.toLowerCase().replace(/\s+/g, '-')}/${temple.id}`} key={temple.id} class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4 mb-10">
                    <div className="ml-10 sm:ml-0 sm:mt-10">
                      <p className="text-16">{temple.name}</p>
                    </div>
                  </a>
                ))}
                */}
                {templesList.map((temple) => (
                  <a href={`/indian-temple/id/${temple.id}/${temple.name.toLowerCase().replace(/\s+/g, '-')}`} key={temple.id} class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4 mb-10">
                    <div className="ml-10 sm:ml-0 sm:mt-10">
                      <p className="text-16">{temple.name}</p>
                    </div>
                  </a>
                ))}
              </div>
              <div data-anim-child="slide-up delay-2" class="col-xl-4 col-lg-3 col-6 is-in-view">
                {attractionsList.map((attraction) => (
                  <a target="_blank" href={`/attractions/${attraction.title.toLowerCase().replace(/\s+/g, '-')}/${attraction.id}`} key={attraction.id} class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4 mb-10">
                    <div className="ml-10 sm:ml-0 sm:mt-10">
                      <p className="text-16">{attraction.title}</p>
                    </div>
                  </a>
                ))}
              </div>

              <div data-anim-child="slide-up delay-2" class="col-xl-4 col-lg-3 col-6 is-in-view">
                {eateriesList.map((eateries) => (
                  <a target="_blank" href={`/eateries/${eateries.title.toLowerCase().replace(/\s+/g, '-')}/${eateries.id}`} key={eateries.id} class="citiesCard -type-5 d-flex items-center sm:flex-column sm:items-start px-20 py-20 sm:px-15 sm:py-20 bg-light-2 rounded-4 mb-10">
                    <div className="ml-10 sm:ml-0 sm:mt-10">
                      <p className="text-16">{eateries.title}</p>
                    </div>
                  </a>
                ))}
              </div>
          </div>
        </div>
      </section>

      <section class="layout-pt-md layout-pb-lg">
        <div class="container">
          <div class="row justify-center text-center">
            <div class="col-auto">
              <div class="sectionTitle -md">
                <h2 class="sectionTitle__title">Other Hotels that might interest you</h2>
                <p class=" sectionTitle__text mt-5 sm:mt-0">Some of the exciting hotels that are similar</p>
              </div>
            </div>
          </div>

          <div class="row y-gap-30 pt-40 sm:pt-20">

          {similarHotels.length > 0 && similarHotels.map(hotel => (
            <div class="col-xl-3 col-lg-3 col-sm-6">
              <a href={`/hotel/${hotel.name.toLowerCase().replace(/\s+/g, '-')}/${hotel.id}`} class="hotelsCard -type-1">
                <div class="hotelsCard__image">
                  <div class="cardImage ratio ratio-1:1">
                    <div class="cardImage__content">
                      <img class="rounded-4 col-12" src={
                        hotel.thumb_new
                          ? (hotel.thumb_new.includes('aim_')
                            ? `/img/uploads/hotels/gallery/${hotel.thumb_new}`
                            : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${hotel.thumb_new}`)
                          : '' // Empty string if thumb_new is null or undefined
                      } alt="image" />
                    </div>
                  </div>
                </div>
                <div class="hotelsCard__content mt-10">
                  <h4 class="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                    <span>{hotel.name}</span>
                  </h4>
                  <p class="text-light-1 lh-14 text-14 mt-5">{cityState.length > 0 && `${cityState[0].city}, ${cityState[0].state}`}</p>
                  <div class="mt-5">
                    <div class="fw-500">
                      {hotel.price > 0 ?
                        <span dangerouslySetInnerHTML={{ __html: `Starting from <span class="text-blue-1">₹${hotel.price}</span>` }}></span> : 'Contact us for Price'
                      }
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))}



          </div>
        </div>
      </section>
      <SubscribeRibbon />
    </div>
    </>
  );
}

export default Hotel;
